var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineSquareArrowUpright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.92705 6.8241C5.7292 6.8241 5.56804 6.98527 5.56804 7.1831V18.0651C5.56804 18.2629 5.7292 18.4241 5.92705 18.4241H16.809C17.0069 18.4241 17.168 18.2629 17.168 18.0651V12.6272C17.168 12.1916 17.5212 11.8384 17.9568 11.8384C18.3924 11.8384 18.7456 12.1916 18.7456 12.6272V18.0651C18.7456 19.1342 17.8782 20.0016 16.809 20.0016H5.92705C4.85795 20.0016 3.99048 19.1342 3.99048 18.0651V7.1831C3.99048 6.11399 4.85795 5.24654 5.92705 5.24654H11.3649C11.8005 5.24654 12.1537 5.59969 12.1537 6.03532C12.1537 6.47095 11.8005 6.8241 11.3649 6.8241H5.92705Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6592 4.78719C14.6592 4.35156 15.0124 3.99841 15.448 3.99841H19.2112C19.6469 3.99841 20 4.35156 20 4.78719C20 5.22282 19.6469 5.57597 19.2112 5.57597H15.448C15.0124 5.57597 14.6592 5.22282 14.6592 4.78719Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2112 3.99841C19.6469 3.99841 20 4.35156 20 4.78719V8.55041C20 8.98604 19.6469 9.33919 19.2112 9.33919C18.7756 9.33919 18.4224 8.98604 18.4224 8.55041V4.78719C18.4224 4.35156 18.7756 3.99841 19.2112 3.99841Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.769 4.22944C20.077 4.53748 20.077 5.03691 19.769 5.34494L12.8697 12.2442C12.5617 12.5522 12.0623 12.5522 11.7542 12.2442C11.4462 11.9361 11.4462 11.4367 11.7542 11.1287L18.6535 4.22944C18.9615 3.9214 19.4609 3.9214 19.769 4.22944Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineSquareArrowUpright);
export default __webpack_public_path__ + "static/media/line-square-arrow-upright.87eb3ff3f27b00168c1aa458380f7400.svg";
export { ForwardRef as ReactComponent };